import { NewReservationAction } from "~/reducers/newReservation"
import ILineItem from "~/interfaces/ILineItem"
import { LineItemParams, mapLineItemToParams } from "~/api2/orders"
import { NewReservationProps } from "~/interfaces"

const reservationTypeExplainer = (timing: string): string => {
  switch (timing) {
    case "recurring":
      return "Recurring reservations will break into monthly segments for sending invoices to long-term guests"
    case "group":
      return "Group reservations can hold multiple sites for a group and allow them to pay separately or together"
    case "blocked":
      return "Blocked reservations will prevent a site from being booked"
    default:
      return "Single reservations are the standard use case for booking a guest in"
  }
}

const returnActionTypeFeeByProp = (key: string) => {
  switch (key) {
    case "is_holiday_rate_enabled":
      return NewReservationAction.UPDATE_IS_HOLIDAY_RATE_ENABLED
    case "is_passenger_fees_enabled":
      return NewReservationAction.UPDATE_IS_PASSENGER_FEES_ENABLED
    case "is_weekend_fee_enabled":
      return NewReservationAction.UPDATE_IS_WEEKEND_FEE_ENABLED
    case "is_pets_fee_enabled":
      return NewReservationAction.UPDATE_IS_PETS_FEE_ENABLED
    case "is_tax_enabled":
      return NewReservationAction.UPDATE_IS_TAX_ENABLED
    default:
      return NewReservationAction.UPDATE_IS_CREDIT_CARD_FEE_ENABLED
  }
}

const mapLineItemsToPriceDetailParams = (lineItems: Partial<ILineItem>[], isTaxEnabled: boolean): LineItemParams[] =>
  lineItems
    ?.filter((li) => li.add_on_id && li.add_on_id !== "change-me" && !li?.reservation_id && !li?.parent_line_item_id)
    ?.filter((li, index, self) => self.findIndex((item) => item.add_on_id === li.add_on_id) === index)
    ?.map((li) => mapLineItemToParams(li, isTaxEnabled))

export { reservationTypeExplainer, returnActionTypeFeeByProp, mapLineItemsToPriceDetailParams }
